// OLD wich doesnt have nextslide

// import Swiper from "swiper";
// import { Pagination, Navigation } from "swiper/modules";

// class VideoSlider {
//   constructor() {
//     this.initSwiper();
//   }

//   initSwiper() {
//     this.videos = document.querySelectorAll(".lc-startpage-hero-slide__video");
//     this.playButton = document.getElementById("playBtn");
//     this.pauseButton = document.getElementById("pauseBtn");

//     if (!this.videos.length || !this.playButton || !this.pauseButton) return;

//     this.currentVideo = this.videos[0];

//     this.swiper = new Swiper(".lc-swiper-hero--video", {
//       modules: [Pagination, Navigation],
//       slidesPerView: 1,
//       loop: false,
//       navigation: {
//         nextEl: ".swiper-button-next--video",
//         prevEl: ".swiper-button-prev--video",
//       },
//       pagination: {
//         el: ".swiper-pagination--video",
//         clickable: true,
//         type: "bullets",
//         renderBullet: (index, className) => {
//           return `<div class="${className}"><span></span></div>`;
//         },
//       },
//       on: {
//         init: () => this.currentVideo.play(),
//         slideChange: () => this.handleVideoChange(),
//       },
//     });

//     this.initVideoControls();
//   }

//   initVideoControls() {
//     this.playButton.addEventListener("click", () => this.togglePlayPause());
//     this.pauseButton.addEventListener("click", () => this.togglePlayPause());
//     this.videos.forEach(video => {
//       video.addEventListener("timeupdate", this.updateProgressBar.bind(this));
//       video.addEventListener("ended", this.nextSlide.bind(this));
//     });
//   }

//   togglePlayPause() {
//     if (this.currentVideo.paused) {
//       this.currentVideo.play();
//       this.playButton.style.display = "none";
//       this.pauseButton.style.display = "block";
//     } else {
//       this.currentVideo.pause();
//       this.playButton.style.display = "block";
//       this.pauseButton.style.display = "none";
//     }
//   }

//   handleVideoChange() {
//     if (!this.currentVideo) return;

//     this.currentVideo.pause();
//     this.currentVideo.currentTime = 0;
//     // this.currentVideo.removeEventListener("timeupdate", this.updateProgressBar);
//     // this.currentVideo.removeEventListener("ended", this.nextSlide);
//     this.currentVideo = this.videos[this.swiper.realIndex];

//     if (!this.currentVideo) return;
//     this.currentVideo.currentTime = 0;
//     this.currentVideo.play();
//     this.playButton.style.display = "none";
//     this.pauseButton.style.display = "block";
//     // this.currentVideo.addEventListener("timeupdate", this.updateProgressBar.bind(this));
//     // this.currentVideo.addEventListener("ended", this.nextSlide.bind(this), { once: true });
// }


//   updateProgressBar = () => {
//     const bullets = document.querySelectorAll(".lc-swiper-hero--video .swiper-pagination-bullet span");
//     const progress = (this.currentVideo.currentTime / this.currentVideo.duration) * 100;

//     if (bullets[this.swiper.realIndex]) {
//       bullets[this.swiper.realIndex].style.width = `${progress}%`;
//     }
//   };

//   nextSlide = () => {
//     if (this.swiper.realIndex < this.videos.length - 1) {
//       this.swiper.slideNext();
//     }
//   };
// }

// export default VideoSlider;

import Swiper from "swiper";
import { Pagination, Navigation } from "swiper/modules";

class VideoSlider {
  constructor() {
    this.mediaQuery = window.matchMedia("(min-width: 768px)");
    this.handleResize();
    this.mediaQuery.addEventListener("change", this.handleResize.bind(this));

  }

  handleResize() {
    if (this.mediaQuery.matches) {
      this.initSwiper();
    } else {
      this.destroySwiper();
    }
  }

  initSwiper() {
    if (this.swiper) return; // Prevents re-initialization

    this.videos = document.querySelectorAll(".lc-startpage-hero-slide__video");
    this.playButton = document.getElementById("playBtn");
    this.pauseButton = document.getElementById("pauseBtn");

    if (!this.videos.length || !this.playButton || !this.pauseButton) return;

    this.currentVideo = this.videos[0];

    this.swiper = new Swiper(".lc-swiper-hero--video", {
      modules: [Pagination, Navigation],
      slidesPerView: 1,
      loop: false,
      pagination: {
        el: ".swiper-pagination--video",
        clickable: true,
        type: "bullets",
        renderBullet: (index, className) => {
          return `<div class="${className}"><span></span></div>`;
        },
      },
      on: {
        init: () => this.currentVideo.play(),
        slideChange: () => this.handleVideoChange(),
      },
    });

    this.initVideoControls();
  }

  destroySwiper() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }

  initVideoControls() {
    this.playButton.addEventListener("click", () => this.togglePlayPause());
    this.pauseButton.addEventListener("click", () => this.togglePlayPause());
    this.videos.forEach(video => {
      video.addEventListener("timeupdate", this.updateProgressBar.bind(this));
      video.addEventListener("ended", this.nextSlide.bind(this));
    });

    const swiperNextBtn = document.querySelector(".swiper-button-next--video");
    const swiperPrevBtn = document.querySelector(".swiper-button-prev--video");

    if (swiperNextBtn) {
      swiperNextBtn.addEventListener("click", (event) => {
        event.preventDefault();
        this.nextSlide();
      });
    }

    if (swiperPrevBtn) {
      swiperPrevBtn.addEventListener("click", (event) => {
        event.preventDefault();
        this.previousSlide();
      });
    }
  }

  togglePlayPause() {
    if (this.currentVideo.paused) {
      this.currentVideo.play();
      this.playButton.style.display = "none";
      this.pauseButton.style.display = "block";
    } else {
      this.currentVideo.pause();
      this.playButton.style.display = "block";
      this.pauseButton.style.display = "none";
    }
  }

  handleVideoChange() {
    if (!this.currentVideo) return;

    this.currentVideo.pause();
    this.currentVideo.currentTime = 0;
    this.currentVideo = this.videos[this.swiper.realIndex];

    if (!this.currentVideo) return;
    this.currentVideo.currentTime = 0;
    this.currentVideo.play();
    this.playButton.style.display = "none";
    this.pauseButton.style.display = "block";
  }

  updateProgressBar = () => {
    if (!this.swiper) return; // Prevent error
    const bullets = document.querySelectorAll(".lc-swiper-hero--video .swiper-pagination-bullet span");
    const progress = (this.currentVideo.currentTime / this.currentVideo.duration) * 100;

    if (bullets[this.swiper.realIndex]) {
      bullets[this.swiper.realIndex].style.width = `${progress}%`;
    }
  };

  nextSlide = () => {
    if (!this.swiper) return; // Prevent error
    if (this.swiper.realIndex < this.videos.length - 1) {
      this.swiper.slideNext();
    } else {
      this.swiper.slideTo(0);
    }
  };

  previousSlide = () => {
    if (!this.swiper) return; // Prevent error
    if (this.swiper.realIndex > 0) {
      this.swiper.slidePrev();
    } else {
      this.swiper.slideTo(this.videos.length - 1);
    }
  };
}

export default VideoSlider;

